import { PropsWithChildren } from 'react'

import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography'
import { makeStyles } from '@material-ui/core/styles'

type FlowActionInlineFormProps = PropsWithChildren<{
  title: string
  canApply?: boolean
  onCancel: () => void
  onApply: () => void
}>

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    borderRadius: 12,
    border: '1px solid var(--ds-border-default, #d7dae4)',
    background: 'var(--ds-bg-surface, #ffffff)',
    padding: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    animation: '$expand 160ms ease-out',
  },
  title: {
    fontSize: '0.875rem',
    fontWeight: 600,
    color: 'var(--ds-fg-primary, #1f2430)',
  },
  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: theme.spacing(1),
  },
  button: {
    textTransform: 'none',
    borderRadius: 10,
    fontWeight: 600,
    boxShadow: 'none',
  },
  secondaryButton: {
    border: '1px solid var(--ds-border-default, #d7dae4)',
    background: 'var(--ds-bg-subtle, #f1f2f7)',
    color: 'var(--ds-fg-primary, #1f2430)',
  },
  primaryButton: {
    background: 'var(--ds-bg-subtle, #f1f2f7)',
    color: 'var(--ds-fg-primary, #1f2430)',
  },
  '@keyframes expand': {
    from: {
      opacity: 0,
      transform: 'translateY(-4px)',
    },
    to: {
      opacity: 1,
      transform: 'translateY(0)',
    },
  },
}))

const FlowActionInlineForm = ({
  title,
  canApply = false,
  onCancel,
  onApply,
  children,
}: FlowActionInlineFormProps) => {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <Typography className={classes.title}>{title}</Typography>
      <div>{children}</div>
      <div className={classes.actions}>
        <Button className={`${classes.button} ${classes.secondaryButton}`} onClick={onCancel}>
          Cancel
        </Button>
        <Button
          className={`${classes.button} ${classes.primaryButton}`}
          disabled={!canApply}
          onClick={onApply}
        >
          Apply
        </Button>
      </div>
    </div>
  )
}

export default FlowActionInlineForm
